import { StateDispatchProps } from "../components/state-dispatch.props";
import { QqKeyInfoItemLink } from "../model/qq-key-info-item.model";
import { Link } from "@mui/material";
import Box from "@mui/material/Box";
import { LinkTypography } from "./qq-typohraphy.controls";

export type QqResLinkControlProps = StateDispatchProps & QqKeyInfoItemLink;

export const QqResLinkControl: React.FunctionComponent<QqResLinkControlProps> =
  ({ text, href }) => {
    return (
      <Box
        sx={{
          marginBottom: "24px",
        }}
      >
        <Link underline="none" href={href} target="_blank">
          <LinkTypography>{text}</LinkTypography>
        </Link>
      </Box>
    );
  };
